import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

class CtaButtonLg extends Component {

  render() {
    const { children } = this.props
    return (
      <CtaButtonLgContainer>
        <Link to={this.props.to}>
          {children}
        </Link>
      </CtaButtonLgContainer>
    )
  }
}

export default CtaButtonLg

const CtaButtonLgContainer = styled.div`
  background: #43AB60;
  display: inline-block;
  color: white;
  border-radius: 4px;
  padding: 20px 40px;
  transition: all 300ms ease;
  
  &:hover {
    background: #53d376;
    cursor: pointer;
  }
  
  a {
    color: white;
    font-size: 2.5rem;
    font-weight: 600;
    text-decoration: none;
  }
  
`


// WEBPACK FOOTER //
// ./src/components/UI/CtaButtonLg.jsx